import urlService from './rbata.urlService';
import logger from '../utils/rbata.logger';

const notifyMeService = {
    notifyMeModal:     undefined,
    notifyMeModalBody: undefined,
    successTimeout:    undefined,
    submitButton:      undefined,
    showNotifyMeModal(productCode) {
        if (!this.notifyMeModal) {
            this.notifyMeModal     = $('#notifyme-modal');
            this.notifyMeModalBody = $('#js-notifyme-modal__body');
        }
        this.notifyMeModal.modal('show');
        this.fetchNotifyMeContent(productCode);
    },
    hideNotifyMeModal() {
        this.notifyMeModal.modal('hide');
    },
    cacheSelectors() {
        this.submitButton = $('#js-submit-notifyme-form');
        this.inputEmail   = $('#stockNotificationForm__email');
    },
    fetchNotifyMeContent(productCode) {
        $.ajax({
            url:    `${urlService.getBaseUrl()}p/${productCode}/notify/`,
            method: 'GET',
            cache:  false
        }).then((data) => {
            this.notifyMeModalBody.html(data);
            this.cacheSelectors();
            this.bindSubmitHandler();
        }, (jqXHR) => {
            logger.error(`${jqXHR.status} error in fetchNotifyMeContent`);
        });

    },
    submitNotifyMeForm(url) {
        if (this.inputEmail.val() !== '') {
            this.submitButton.prop('disabled', true);
            $.ajax({
                url:         url,
                method:      'POST',
                data:        `email=${this.inputEmail.val()}`,
                contentType: 'application/x-www-form-urlencoded'
            }).done((data) => {
                this.notifyMeModalBody.html(data);
                this.showSuccessNotifyMessage();
            }).fail(() => {
                logger.log('Failed to request notify me action');
                this.submitButton.prop('disabled', true);
            });
        } else {
            this.inputEmail.focus();
        }
    },
    bindSubmitHandler() {
        this.submitButton.on('click', (evt) => {
            evt.preventDefault();
            this.submitNotifyMeForm(evt.currentTarget.dataset.action);
        });
    },
    showSuccessNotifyMessage() {
        notifyMeService.successTimeout = setTimeout(() => {
            this.closeSuccessNotifyMessage()
        }, 5000);
    },
    closeSuccessNotifyMessage() {
        clearTimeout(notifyMeService.successTimeout);
        this.hideNotifyMeModal();
    }
};

export default notifyMeService;
